<template>
  <div>
    <Header v-if="isAdmin" />
    <Table />
  </div>
</template>

<script>
import Header from "./group/Toolbar";
import Table from "./group/Table";
export default {
  components: {
    Header,
    Table
  }
};
</script>

<style></style>
